import {
  mockAllPlansIncludeItems,
  mockShowCaseItems,
  mockStudioOfferingCardsMarketingItems,
} from '../__tests__/mocks/DealerMocks/list-offers-mocks';
import {
  Brands,
  Country,
  Language,
  PageTitleKeys,
  PaymentCycle,
  PlanType,
  RealEstateId,
  SectionCategory,
  Theme,
  Vertical,
} from './enums';

export const PREMIUM_PURCHASE_PLAN_ARTIFACT_ID =
  'com.wixpress.premium-purchase-plan';

export const DOMAIN_PURCHASE_INTENT_REFERRAL = 'add-domain-purchase-intent';
export const DOMAIN_PURCHASE_INTENT_FUNNEL_REFERRAL =
  'add-domain-purchase-intent-funnel';
export const DOMAIN_CONNECT_INTENT_FUNNEL_REFERRAL =
  'add-domain-connect-intent-funnel';

/*
TODO: Export CardBrands from separate dir in payment-methods-icons package.
*/
export enum CardBrands {
  Amex = 'amex',
  BankTransfer = 'bankTransfer',
  Boleto = 'boleto',
  CarteBlue = 'carteBlue',
  CreditsPrepaidCard = 'creditsPrepaidCard',
  Diners = 'diners',
  Discover = 'discover',
  Elo = 'elo',
  Jcb = 'jcb',
  Maestro = 'maestro',
  Mastercard = 'mastercard',
  MercadoPagoRecurring = 'mercadoPagoRecurring',
  MpBanamex = 'mpBanamex',
  MpBancomer = 'mpBancomer',
  MpOxxo = 'mpOxxo',
  Payu = 'payu',
  MpSerfin = 'mpSerfin',
  RegDotRu = 'regDotRu',
  SepaDirectDebit = 'sepaDirectDebit',
  Solo = 'solo',
  Unionpay = 'unionpay',
  Visa = 'visa',
  Sofort = 'sofort',
}

export const ProductTypeIds = {
  PremiumPlans: '8b1b47e6-9f58-4e59-b147-cac894bec8da',
  DayfulPlans: 'b5824dc4-dfe0-447b-8e00-f6ab5c326ef6',
};

export const DefaultMetaSiteId = '1952eea0-7267-402f-bcfd-85653973e315';

export const WEBSITE_VERTICALS: Vertical[] = [
  Vertical.Music,
  Vertical.Video,
  Vertical.Default,
];

export const plansPageTabs = [
  PlanType.Website,
  PlanType.Business,
  PlanType.Enterprise,
];

export const appName = 'premium-purchase-plan';

export const PETRI_SCOPES = {
  PremiumPurchasePlan: 'premium-purchase-plan',
};

export const CycleMultiplier = {
  [PaymentCycle.YEAR3]: 36,
  [PaymentCycle.YEAR2]: 24,
  [PaymentCycle.YEARLY]: 12,
  [PaymentCycle.QUARTERLY]: 3,
  [PaymentCycle.MONTHLY]: 1,
};

export const advancedShippingFeature = {
  key: 'advanced_shipping',
  icon: 'advancedShipping',
};

export const AcceptedPaymentMethodsFallback = [
  CardBrands.Visa,
  CardBrands.Mastercard,
  CardBrands.Amex,
  CardBrands.Discover,
];

export const supportedLangs = [
  'cs',
  'da',
  'de',
  'en',
  'es',
  'fi',
  'fr',
  'hi',
  'it',
  'ja',
  'ko',
  'nl',
  'no',
  'pl',
  'pt',
  'ru',
  'sv',
  'th',
  'tr',
  'uk',
  'zh',
];
export const trustedDomains = ['wix.com'];

export const TermsOfUseLinksByBrand: {
  [key: string]: { [T in 'terms' | 'privacy' | 'enterprise']: string };
} = {
  [Brands.WIX]: {
    privacy: 'https://www.wix.com/about/privacy',
    terms: 'https://www.wix.com/about/terms-of-use',
    enterprise: 'https://www.wix.com/about/terms-use-enterprise',
  },
  [Brands.EDITOR_X]: {
    privacy: 'https://www.editorx.com/info/privacy',
    terms: 'https://www.editorx.com/info/terms-of-use',
    enterprise: '',
  },
  // TODO - Fix links once dayful domain is launched
  [Brands.DAYFUL]: {
    privacy: 'https://www.dayful.com/info/privacy',
    terms: 'https://www.dayful.com/info/terms-of-use',
    enterprise: '',
  },
  studio: {
    privacy: 'https://www.dayful.com/info/privacy',
    terms: 'https://www.dayful.com/info/terms-of-use',
    enterprise: '',
  },
};

export const taxIncludedCountries = [
  Country.DE,
  Country.IL,
  Country.FR,
  Country.AU,
];
export const taxIncludedTranslationKey: {
  [key in Country.DE | Country.IL | Country.FR | Country.AU]: string;
} = {
  [Country.DE]: 'product.vat',
  [Country.FR]: 'product.vat',
  [Country.IL]: 'product.vat',
  [Country.AU]: 'product.gst',
};

const AppIntentElementsFallback = {
  website: PageTitleKeys.PLANS,
  business: PageTitleKeys.BUSINESS,
  enterprise: PageTitleKeys.ENTERPRISE,
  landingTab: PlanType.Website,
  recommendedSection: SectionCategory.DEFAULT,
  intent: Vertical.Default,
};

const WixStudioAllPlansIncludeFallback = {
  ...mockAllPlansIncludeItems.offers?.[0].asset?.creative,
};

const WixStudioShowCaseItemsFallback = {
  ...mockShowCaseItems.offers?.[0].asset?.creative,
};

export const RealEstatesDefaultOffers = {
  [RealEstateId.AcceptPaymentMethods]: AcceptedPaymentMethodsFallback,
  [RealEstateId.AppIntentElementsInitialPurchase]: AppIntentElementsFallback,
  [RealEstateId.AppIntentElementsSecondUpgrade]: AppIntentElementsFallback,
  [RealEstateId.WixStudioAllPlansInclude]: WixStudioAllPlansIncludeFallback,
  [RealEstateId.WixStudioShowCaseItems]: WixStudioShowCaseItemsFallback,
  [RealEstateId.WixStudioMarketingCards]: {
    ...mockStudioOfferingCardsMarketingItems,
  },
  [RealEstateId.SunriseMarketingCards]: {},
};

export const SunriseRealEstatesDefaultOffers = {
  [RealEstateId.AcceptPaymentMethods]: AcceptedPaymentMethodsFallback,
  [RealEstateId.AppIntentElementsInitialPurchase]: {
    website: 'premium-purchase-plan.header.default.title',
    business: 'premium-purchase-plan.header.default.title',
    enterprise: 'premium-purchase-plan.header.default.title',
    landingTab: PlanType.Business,
    recommendedSection: SectionCategory.ONLINE_BOOKINGS_CALENDAR,
    intent: Vertical.Default,
  },
  [RealEstateId.AppIntentElementsSecondUpgrade]: {
    website: 'premium-purchase-plan.header.second_upgrade.title',
    business: 'premium-purchase-plan.header.second_upgrade.title',
    enterprise: 'premium-purchase-plan.header.second_upgrade.title',
    landingTab: PlanType.Business,
    recommendedSection: SectionCategory.DEFAULT,
    intent: Vertical.Default,
  },
};

export const AscendBundleHelperKeys: string[] = [
  'subscription_page.ascend_bundle_helper.body_email.campaigns',
  'subscription_page.ascend_bundle_helper.body_social.posts',
  'subscription_page.ascend_bundle_helper.body_chatbox',
  'subscription_page.ascend_bundle_helper.body_automations',
];

export const faqSubtitleMap: {
  [key in Theme]: { [faqSubtitle: string]: string };
} = {
  [Theme.Default]: {
    faqSubtitle: 'faq_section.faq_subtitle_support',
  },
  [Theme.AdvancedPlans]: {
    faqSubtitle: 'faq_section.faq_subtitle_support',
  },
  [Theme.EditorX]: { faqSubtitle: 'faq_section.editorx_faq_subtitle_support' },
  [Theme.Dayful]: { faqSubtitle: 'faq_section.faq_subtitle_support' },
  [Theme.WixStudio]: { faqSubtitle: 'faq_section.faq_subtitle_support' },
};

export const faqEnterpriseCodeMap = {
  right_for_my_business: 'right_for_my_business',
  how_to_contact: 'how_to_contact',
  build_for_large_scale: 'build_for_large_scale',
  security: 'security',
  education_programs: 'education_programs',
};

export const faqCodeMap: { [key in Theme]: { [key: string]: string } } = {
  [Theme.Default]: {
    premiumPlan: 'faq.what_is_a_premium_plan',
    premiumPlanNoVoucher: 'faq.what_is_a_premium_plan_no_vouchers',
    canITry: 'faq.can_i_try_wix_premium_for_free',
    customDomain: 'faq.why_do_i_need_a_custom_domain',
    myDomain: 'faq.how_do_i_get_my_domain',
    emailAddress: 'faq.how_do_i_get_my_email_address',
    whatOnlinePayments: 'faq.what_online_payments_are_accepted',
    googleVoucher: 'faq.which_plans_come_with_vouchers',
    billingInfo: 'faq.billing_information',
  },
  [Theme.AdvancedPlans]: {
    premiumPlan: 'faq.what_is_a_premium_plan',
    premiumPlanNoVoucher: 'faq.what_is_a_premium_plan_no_vouchers',
    canITry: 'faq.can_i_try_wix_premium_for_free',
    customDomain: 'faq.why_do_i_need_a_custom_domain',
    myDomain: 'faq.how_do_i_get_my_domain',
    emailAddress: 'faq.how_do_i_get_my_email_address',
    whatOnlinePayments: 'faq.what_online_payments_are_accepted',
    googleVoucher: 'faq.which_plans_come_with_vouchers',
    billingInfo: 'faq.billing_information',
  },
  [Theme.EditorX]: {
    premiumPlan: 'faq.editorx.what_is_a_premium_plan',
    premiumPlanNoVoucher: 'faq.editorx.what_is_a_premium_plan_no_vouchers',
    canITry: 'faq.can_i_try_editorx_premium_for_free',
    customDomain: 'faq.editorx.why_do_i_need_a_custom_domain',
    myDomain: 'faq.editorx.how_do_i_get_my_domain',
    emailAddress: 'faq.how_do_i_get_my_email_address',
    whatOnlinePayments: 'faq.editorx_what_online_payments_are_accepted',
    googleVoucher: 'faq.editorx_which_plans_come_with_vouchers',
    billingInfo: 'faq.editorx.billing_information',
    transition: 'faq.editorx.studio.transition',
    difference: 'faq.editorx.studio.difference',
    studio: 'faq.editorx.studio',
  },
  [Theme.Dayful]: {
    premiumPlan: 'faq.dayful.what_is_a_premium_plan',
    premiumPlanNoVoucher: 'faq.dayful.what_is_a_premium_plan',
    canITry: 'faq.can_i_try_dayful_premium_for_free',
    whatOnlinePayments: 'faq.dayful_what_online_payments_are_accepted',
  },
  [Theme.WixStudio]: {
    what_is_studio: 'studio_package_picker.FAQ.what_is_studio',
    what_is_studio_plan: 'studio_package_picker.FAQ.what_is_studio_plan',
    try_for_free: 'studio_package_picker.FAQ.try_for_free',
    free_domain: 'studio_package_picker.FAQ.free_domain',
    personalized_email: 'studio_package_picker.FAQ.personalized_email',
    is_enterprise_right: 'studio_package_picker.FAQ.is_enterprise_right',
    transfer_ownership: 'studio_package_picker.FAQ.transfer_ownership',
    what_is_workspace: 'studio_package_picker.FAQ.anon.what_is_workspace',
    who_is_collaborator: 'studio_package_picker.FAQ.who_is_collaborator',
    who_is_teammate: 'studio_package_picker.FAQ.who_is_teammate',
    design_tools: 'studio_package_picker.FAQ.design_tools',
  },
};

export const EnterpriseLanguageToFormURL = new Map([
  ['de', 'https://de.wix.com/enterprise/form'],
  ['en', 'https://www.wix.com/enterprise/form'],
  ['es', 'https://es.wix.com/enterprise/form'],
  ['fr', 'https://fr.wix.com/enterprise/form'],
  ['js', 'https://ja.wix.com/enterprise/form'],
  ['pt', 'https://pt.wix.com/enterprise/form'],
]);

// export const SHORT_STUDIO_PLANS_PATH = '/studio/plans';
// TODO: Remove this once the new path is launched
export const SHORT_STUDIO_PLANS_PATHS = [
  '/studio/plans',
  '/pp-fold-test/plans2',
];

export const NEW_STUDIO_URL = '/premium-pricing/studio';

export const STUDIO_ROUTE_LANGUAGES: Language[] = [
  Language.EN,
  Language.ES,
  Language.PT,
  Language.FR,
  Language.DE,
  Language.JA,
  Language.IT,
];
